module.exports = __webpack_public_path__ + "media/images/media-elements/play-overlay-0ae15fa79dd43e180a67d60fa4c9fec9.svg";